import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { ComponentBase, RentalObjectInfo, ObjectTypeInfo } from 't4core';


@Component({
    selector: 'title-with-divider',
    templateUrl: './title-with-divider.html',
    standalone: false
})
export class TitleWithDividerComponent extends ComponentBase implements OnInit {

  @Input() public Title: string;
  @Input() public titlewithmargin: boolean = false;
  constructor() {
    super();
  }

  ngOnInit(): void {
  }
}
